var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEt = function SvgEt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 720 360"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M0 0h720v360H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0 0h720v240H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M0 0h720v120H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360 180)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 120,
    fill: "#0f47af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "et_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "m0-96-4.206 12.944 17.348 53.39h-23.13l-2.599 8h74.163l11.011-8H21.553z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcdd09",
    strokeWidth: 4,
    d: "m25.863-35.597 30.564-42.069"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#et_svg__a",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#et_svg__a",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#et_svg__a",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#et_svg__a",
    transform: "rotate(288)"
  }))));
};
export default SvgEt;